import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraTabBar } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
const T = Testids.sharedRecord;
/**
 * Section frame for a full shared record (C7A-06). Callers pass only the
 * sections that exist for that record — e.g. Capabilities for our own Company —
 * so a section that doesn't apply is absent, not disabled.
 */ export function RecordSections({ label, sections }) {
    const [active, setActive] = useState(sections[0]?.key ?? '');
    const current = sections.find((s)=>s.key === active) ?? sections[0];
    if (!current) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-4",
        "data-testid": T.sectionTabs,
        children: [
            /*#__PURE__*/ _jsx(SpecraTabBar, {
                label: label,
                value: current.key,
                onValueChange: setActive,
                options: sections.map((s)=>({
                        value: s.key,
                        label: s.label
                    }))
            }),
            /*#__PURE__*/ _jsx("div", {
                "data-testid": T.sectionPanel,
                "data-section": current.key,
                children: current.content
            })
        ]
    });
}
/** States what an edit changes, so a shared edit is never mistaken for a local one (C7A-07). */ export function SharedEditNotice({ record, scope }) {
    return /*#__PURE__*/ _jsxs("p", {
        className: "rounded-md border border-border bg-muted px-3 py-2 text-xs text-muted-foreground",
        "data-testid": T.editNotice,
        children: [
            "Editing here changes the shared ",
            record,
            " for everyone who references it (",
            scope,
            "). Pursuit- or program-specific values are edited where they live, not here."
        ]
    });
}
/** Honest state for a section with no supporting API: says so and names the manual route. */ export function SectionUnavailable({ children }) {
    return /*#__PURE__*/ _jsx("output", {
        className: "block rounded-md border border-border bg-muted px-3 py-2 text-sm text-muted-foreground",
        "data-testid": T.sectionUnavailable,
        children: children
    });
}
